module.exports = __webpack_public_path__ + "img/bitpace.bc9b2973.png";